import { render, staticRenderFns } from "./TrainingContent.vue?vue&type=template&id=3cc68fcc&scoped=true&"
import script from "./TrainingContent.vue?vue&type=script&lang=js&"
export * from "./TrainingContent.vue?vue&type=script&lang=js&"
import style0 from "./TrainingContent.vue?vue&type=style&index=0&id=3cc68fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc68fcc",
  null
  
)

export default component.exports